import script from "./OpenCanvasPlacement.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenCanvasPlacement.vue?vue&type=script&setup=true&lang=js"

import "./OpenCanvasPlacement.vue?vue&type=style&index=0&id=19cd9e33&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19cd9e33"]])

export default __exports__